import React, { useState, useEffect } from "react";
import Loader from "../Loader";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Terms from "./Terms";
import styles from "./styles";
import MyAssingment from "./MyAssingment";
import moment from "moment";

// Firebase
import { firestore, auth } from "../../firebase";
// Firebase

// import { useUsuario } from "../../context/usuario-context";

function Assignments(props) {
  let { classes } = props;

  const [load, setLoad] = useState(true);
  const [assignments, setAssignments] = useState([]);

  useEffect(() => {
    const unlisten = auth.onAuthStateChanged((authUser) => {
      firestore
        .collection("assignments")
        .where("userId", "==", authUser.uid)
        .orderBy("dateActivity", "desc")
        .onSnapshot((query) => {
          let assignments = [];
          query.forEach((element) => {
            let data = element.data();
            data.stringDate = moment(data.dateActivity.toDate()).format(
              "DD/MM/YYYY"
            );
            data.hour = moment(data.dateActivity.toDate()).format("HH:mm A");
            assignments.push(data);
          });
          setAssignments(assignments);
          setLoad(false);
        });
    });
    return () => {
      unlisten();
    };
  }, []);

  if (load) {
    return <Loader />;
  }

  return (
    <Grid container spacing={2}>
      {assignments.length === 0 ? (
        <>
          <Grid item xs={12} className={classes.center}>
            <Typography variant="h3" align="center">
              No tienes asignaciones
            </Typography>
          </Grid>
        </>
      ) : (
        <>
          <div
            style={{ width: "100%", textAlign: "center", marginTop: "10px" }}
          >
            <Typography className={classes.name} variant="h3">
              Mis asignaciones
            </Typography>
          </div>
          <Terms classes={classes} />
          <MyAssingment classes={classes} assignments={assignments} />
        </>
      )}
    </Grid>
  );
}

export default withStyles(styles)(Assignments);
